import React, {useEffect, useRef, useState} from "react";
import {Button, Card, Form, Input, InputNumber, Select} from "antd";
import DatePicker from "../../core/components/DatePicker";
import {t} from "i18next";
import {useHistory, useParams} from "react-router-dom";
import moment from "moment";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import FirmSelectList from "../firm/FirmSelectList";
import CashRegisterSelectList from "../cash-register/CashRegisterSelectList";
import {useUser} from "../../core/context/UserContext";
import Helper from "../../core/Helper";
import CurrencySelect from "../../core/components/CurrencySelect";
import {Currency} from "../Payment/MultiplePaymentApp";

export default function ExpenseCreateEdit({})
{
    const history = useHistory();

    const methodsRef = useRef([]);
    const cashRegistersRef = useRef([]);

    const {expenseId} = useParams();
    const [expense, setExpense] = useState({});
    const [methods, setMethods] = useState([])
    const formRef = useRef();
    const [currency, setCurrency] = useState('TRY')
    const {user} = useUser()

    const loadPaymentMethods = async (firmId) => {
        debugger
        if(methodsRef.current.length === 0) {
            const res = await ApiService.PaymentMethod.GetPaymentMethodList();
            if(res.success) {
                methodsRef.current = res.data;
            }
        }

        if(firmId) {
            setMethods(methodsRef.current.filter(x => x?.firm?.id === firmId));
        }
    }

    const getExpense = async () => {
        if(expenseId)
        {
            const res = await ApiService.Expense.GetExpense(expenseId);
            if(res.success)
            {
                setExpense(res.data);
            }
        }
    }

    useEffect(() => {
        getExpense();
    }, [expenseId])

    useEffect(() => {
        formRef.current.setFieldsValue({
            ...expense,
            date: moment(new Date(expense.date))
        })
    }, [expense])

    useEffect(() => {
        formRef.current.setFieldsValue({
            date: moment(),
            amount: 0
        })
    }, [])

    const onFinish = async (formData) => {
        if(expenseId)
        {
            const res = await ApiService.Expense.EditExpense(expenseId, {
                ...formData
            })

            if(res.success)
            {
                history.push(`/app/expenses`)
            }
        }
        else
        {
            const res = await ApiService.Expense.AddExpense({
                ...formData,
            });

            if(res.success)
            {
                history.push(`/app/expenses`)
            }
        }
    }

    return (
        <SimpleLayout>
            <Card title={expenseId ? t('Edit Expense') : t('Add Expense')}>
                <Form
                    layout={'vertical'}
                    onValuesChange={({cashRegisterId, currency}) => {
                        if(cashRegisterId) {
                            loadPaymentMethods(cashRegistersRef.current.find(x => x.id === cashRegisterId)?.firmId)
                            formRef.current.setFieldsValue({
                                paymentMethodId: null
                            })
                        }
                        if(currency) {
                            setCurrency(currency)
                        }
                    }}
                    onFinish={onFinish}
                    initialValues={{
                        currency: currency
                    }}
                    ref={formRef}
                >
                    <Form.Item
                        label={t('Date')}
                        name={'date'}
                        rules={[
                            {required: true}
                        ]}
                    >
                        <DatePicker
                            locale={Helper.Date.getLocale()} showTime={true} style={{width: 400}} format={'DD/MM/yyyy HH:mm'} />
                    </Form.Item>
                    <Form.Item
                        name={'cashRegisterId'}
                        rules={[{required: true}]}
                    >
                        <CashRegisterSelectList
                            style={{width: 400}}
                            placeholder={t('Cash Register')}
                            all={false}
                            onList={(registers) => {
                                cashRegistersRef.current = registers;
                                let reg = user?.userCashRegisters?.find(x => x.isDefault) ?? (user?.userCashRegisters?.length > 0 && user?.userCashRegisters[0])
                                if(reg) {
                                    formRef.current.setFieldsValue({
                                        cashRegisterId: reg.cashRegisterId
                                    })

                                    const register = registers.find(x => x.id === reg.cashRegisterId)
                                    loadPaymentMethods(register.firmId)
                                }
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label={t('Payment Method')}
                        name={'paymentMethodId'}
                        rules={[
                            {required: true}
                        ]}
                    >
                        <Select
                            options={methods}
                            fieldNames={{
                                label: 'name',
                                value: 'id'
                            }}
                            style={{width: 400}}
                            placeholder={t('Payment Method')}
                        />
                    </Form.Item>

                    <Form.Item
                        label={t('Description')}
                        name={'description'}
                        rules={[
                            {required: true}
                        ]}
                    >
                        <Input.TextArea style={{width: 400}} rows={4} />
                    </Form.Item>

                    <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                        <Form.Item
                            label={t('Currency')}
                            name={'currency'}
                        >
                            <CurrencySelect />
                        </Form.Item>
                        <Form.Item
                            label={t('Amount')}
                            name={'amount'}
                            rules={[
                                {required: true}
                            ]}
                        >
                            <InputNumber
                                style={{width: 400}}
                                min={0}
                                prefix={Currency[currency]}

                            />
                        </Form.Item>
                    </div>

                    <Form.Item>
                        <Button type={'primary'} htmlType={'submit'}>{t('Save')}</Button>
                    </Form.Item>
                </Form>
            </Card>
        </SimpleLayout>
    )
}